import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import { logout, onForbidden } from '../account/login';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from "../common/submitForm";

export const REQUEST_SUBMITTED = 'REQUEST_SUBMITTED';
export const REQUEST_REJECTED = 'REQUEST_REJECTED';
export const REQUEST_IN_PROCESS = 'REQUEST_IN_PROCESS';

//- Actions
export const fetchGetAccreditationRequestsFailed = createAction('FETCH_GET_ACCREDITATION_REQUESTS_FAILED');
export const fetchGetAccreditationRequestsSuccess = createAction('FETCH_GET_ACCREDITATION_REQUESTS_SUCCESS');
export const fetchGetAccreditationRequests = createAction(
    'FETCH_GET_ACCREDITATION_REQUESTS',
    () => Api.getAccreditationRequests(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationRequestsSuccess,
        onFail: fetchGetAccreditationRequestsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onCreateAccreditationRequest = (data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchCreateAccreditationRequest(data));
};

export const fetchCreateAccreditationRequest = createAction(
    'FETCH_CREATE_ACCREDITATION_REQUEST',
    (data) => Api.createAccreditationRequest(data),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({
    FETCH_GET_ACCREDITATION_REQUESTS: (state) => {
        return {...state, error: null, fetching: true};
    },
    FETCH_GET_ACCREDITATION_REQUESTS_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_ACCREDITATION_REQUESTS_SUCCESS: (state, action) => {
        return {...state, data: action.payload, error: null, fetching: false};
    }
}, initialState);

//- Selectors
export const getAccreditationRequests = state => state.accreditationRequests;

export const loadingAccreditationRequests = state => getAccreditationRequests(state).fetching;

export const getAccreditationRequestsData = state => getAccreditationRequests(state).data;



// WEBPACK FOOTER //
// ./src/reducers/applicantAccreditations/accreditationRequests.js